export default "__VITE_ASSET__Dsv_45iv__"